import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import { v4 as uuid } from "uuid";

import { invoiceEstimateShape, intlShape } from "../../shapes";

type Props = {
  invoiceEstimate?: invoiceEstimateShape;
  perInvoice?: boolean;
  intl?: intlShape;
};

export function SubscriptionInvoiceEstimate({
  invoiceEstimate,
  perInvoice,
  intl,
}: Props) {
  const lineItems = (type: $TSFixMe, title: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const filtered = invoiceEstimate.lineItems.filter(
      (i) => (i as $TSFixMe).type === type,
    );
    if (filtered.length === 0) {
      return null;
    }
    const nodes = filtered.map((lineItem, index) => (
      <tr id={`line-item-${type}-${index}`} className="line-item" key={uuid()}>
        <td>
          {`${lineItem.description} (${lineItem.quantity} x `}
          <FormattedNumber
            minimumFractionDigits={2}
            maximumFractionDigits={2}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            value={lineItem.amount / lineItem.quantity}
          />
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {` ${invoiceEstimate.currency}`})
        </td>
        <td className="amount">
          <FormattedNumber
            minimumFractionDigits={2}
            maximumFractionDigits={2}
            // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
            value={lineItem.amount}
          />
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {` ${invoiceEstimate.currency}`}
        </td>
      </tr>
    ));

    nodes.unshift(
      <tr id={`line-item-title-${type}`} className="subtitle" key={uuid()}>
        <td>{title}</td>
        <td />
      </tr>,
    );
    return nodes;
  };

  if (invoiceEstimate) {
    const discountLine =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      invoiceEstimate.totalDiscount > 0 ? (
        <tr id="discount" className="discount" key={uuid()}>
          <td className="discount_description">
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            {`${intl.formatMessage({ id: "invoice_estimate.discount" })} (${invoiceEstimate.discountDescription})`}
          </td>
          <td className="amount">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              value={invoiceEstimate.totalDiscount * -1}
            />
            {` ${invoiceEstimate.currency}`}
          </td>
        </tr>
      ) : null;

    const finalTotalLabel = perInvoice ? (
      <td>
        <FormattedMessage id="invoice_estimate.total_due_no_prorata" />
      </td>
    ) : (
      <td>
        <FormattedMessage id="invoice_estimate.total_due" />
      </td>
    );

    const subTotalLine =
      !perInvoice || invoiceEstimate.subTotal !== invoiceEstimate.totalDue ? (
        <tr id="subtotal" className="subtotal" key={uuid()}>
          <td>
            <FormattedMessage id="invoice_estimate.total" />
          </td>
          <td className="amount">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
              value={invoiceEstimate.subTotal}
            />
            {` ${invoiceEstimate.currency}`}
          </td>
        </tr>
      ) : null;

    const creditsLine =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      !perInvoice && invoiceEstimate.credits > 0 ? (
        <tr id="credits" className="credits" key={uuid()}>
          <td>
            <FormattedMessage id="invoice_estimate.credits" />
          </td>
          <td className="amount">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              value={invoiceEstimate.credits * -1}
            />
            {` ${invoiceEstimate.currency}`}
          </td>
        </tr>
      ) : null;

    const proRataDescription = !perInvoice ? (
      <p>
        <FormattedMessage id="invoice_estimate.description" />
      </p>
    ) : null;

    const taxItems =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      invoiceEstimate.totalTaxes > 0
        ? (invoiceEstimate as $TSFixMe).taxes.map(
            (taxItem: $TSFixMe, index: $TSFixMe) => (
              <tr
                id={`line-item-tax-${index}`}
                className="line-item"
                key={uuid()}
              >
                <td>{taxItem.description}</td>
                <td className="amount">
                  <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    value={taxItem.amount}
                  />
                  {` ${invoiceEstimate.currency}`}
                </td>
              </tr>
            ),
          )
        : null;

    const taxLine =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      invoiceEstimate.totalTaxes > 0 ? (
        <tr id="tax-total" className="total" key={uuid()}>
          <td>
            <FormattedMessage id="invoice_estimate.taxes" />
          </td>
          <td className="amount">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
              value={invoiceEstimate.totalTaxes}
            />
            {` ${invoiceEstimate.currency}`}
          </td>
        </tr>
      ) : null;

    return (
      <div className="order-overview">
        <table className="table table-striped">
          <tbody>
            {lineItems("plan", <FormattedMessage id="planvariant.plan" />)}
            {lineItems(
              "outcome",
              <FormattedMessage id="planvariant.outcome" />,
            )}
            {lineItems(
              "connectivity",
              <FormattedMessage id="planvariant.connectivity" />,
            )}
            {lineItems(
              "process_insights",
              <FormattedMessage id="planvariant.process_insights" />,
            )}
            {lineItems("addon", <FormattedMessage id="planvariant.addons" />)}
            {subTotalLine}
            {discountLine}
            {taxItems}
            {taxLine}
            {creditsLine}
            <tr id="final-total" className="final-total" key={uuid()}>
              {finalTotalLabel}
              <td className="amount">
                <FormattedNumber
                  minimumFractionDigits={2}
                  maximumFractionDigits={2}
                  // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
                  value={invoiceEstimate.totalDue}
                />
                {` ${invoiceEstimate.currency}`}
              </td>
            </tr>
          </tbody>
        </table>
        {proRataDescription}
      </div>
    );
  }
  return null;
}

export default injectIntl(SubscriptionInvoiceEstimate);
